<div class="mct-flex mct-row mct-justify-between mct-items-start">
  <h4>{{ 'profiles.view.events' | translate | titlecase }}</h4>
  <div class="mct-flex mct-justify-end mct-items-stretch mct-gap-10">
    <a [ngClass]="{ 'selected-link': !displayAttended, 'disabled-link': displayAttended }" (click)="toggleEventDisplay(false)">{{
      'common.registered' | translate | titlecase
    }}</a>
    <a
      [hidden]="orgInd"
      [ngClass]="{ 'selected-link': displayAttended, 'disabled-link': !displayAttended }"
      (click)="toggleEventDisplay(true)"
      >{{ 'events.attendees.management.attended-column-label' | translate | titlecase }}</a
    >
  </div>
</div>
<div class="events-container">
  <div *ngFor="let event of pagedProfileEvents.Result; let i = index" class="events-container">
    <div class="card-field-label">{{ event.EventDate | date: 'longDate' }}</div>
    <div class="event-name">{{ event.EventName }}</div>
    <div *ngIf="i < pagedProfileEvents.Result.length - 1" class="row-divider"></div>
  </div>
  <wl-paging-controls
    #pagingControls
    [pagedResult]="pagedProfileEvents"
    [hidden]="!showPaging"
    (pagingEvent)="onPagingEvent($event)"
  ></wl-paging-controls>
</div>
